<div class="text-center">
    <div *ngIf=" cameraAccessErrorMessage; else cameraAccessAllowed">
        <p>Your camera is either not plugged in or is not accessible to our website. Also, ensure other applications are not using your camera and the adblock is disabled in your browser. Click <a
                target="_blank"
                href="https://support.google.com/chrome/answer/2693767?co=GENIE.Platform%3DDesktop&hl=en"
            > here </a> for help.
            <br />
            <br />
            Please be sure to allow permission to your camera by clicking the "Allow" button when prompted.
            <br />
        </p>
        <div
            *ngIf="isIPhoneChrome"
            class="error-msg"
        >
            It looks like your using chrome on an iOS device. Please use safari when collecting your picture.
        </div>
        <br />
        Browser Reported Issue: <span class="error-msg">{{cameraAccessErrorMessage}}</span>
    </div>
    <ng-template #cameraAccessAllowed>
        <div
            [ngClass]="{'is-hidden': captured}"
            class="camera-container"
            id="camera-container"
        >
            <video
                #video
                autoplay
                class="video-capture"
            ></video>
            <img
                class="video-overlay"
                [src]="overlayPhoto"
            >
            <div
                class="count-down-overlay"
                [ngClass]="{'is-hidden' : countdownTimeSeconds < 1}"
            >{{countdownTimeSeconds}}</div>
        </div>
        <div *ngIf="!captured; else isCaptured">
            <ul>
                <li>
                    Clear, well lit, and unfiltered
                </li>
                <li>
                    Background is clear, and you are the only one in the photo
                </li>
                <li>
                    Face and shoulders are square to the camera
                </li>
                <li>
                    Neutral facial expression
                </li>
                <li>
                    No head coverings or accessories unless worn for religious or medical purposes
                </li>
                <li>
                    Eyes open and visible, with no eyeglasses unless there is no glare or reflection
                </li>
                <li>
                    Long hair must be tucked behind ears and shoulders
                </li>
            </ul>
            <div
                *ngIf="capturePhotoError"
                class="error-msg"
            >
                <p> {{capturePhotoError}} </p>
            </div>
            <div *ngIf="isPlaying; else waiting">
                <button
                    type="button"
                    class="btn btn-primary m-1"
                    (click)="startPhotoCaptureCountdown()"
                >Take Photo</button>
            </div>
            <ng-template #waiting>
                <i class="fa fa-spinner fa-spin"></i>
                <div> Connecting to media server, please wait...</div>
            </ng-template>
        </div>
        <ng-template #isCaptured>
            <div style="height:capturedPhotoHeight">
                <img
                    style="max-width: 100%;"
                    [src]="capturedPhoto"
                >
            </div>
            <div
                *ngIf="!isUploading && !isUploaded"
                class="btn-toolbar mt-2 justify-content-center"
            >
                <button
                    type="button"
                    class="btn btn-primary m-1"
                    (click)="rejectPhotoShot()"
                > Retry</button>
                <button
                    type="button"
                    class="btn btn-primary m-1"
                    (click)="acceptPhotoShot()"
                > Accept and continue</button>
            </div>
            <div *ngIf="isUploading">
                <i class="fa fa-spinner fa-spin"></i>
                <div> Uploading your picture... </div>
            </div>
            <div
                *ngIf="isUploaded"
                style="margin-top:5px;color:green;"
            >
                <div> Your photo is successfully saved. </div>
            </div>
            <div
                *ngIf="uploadErrorMessage"
                class="error-msg"
            >
                {{uploadErrorMessage}}
            </div>
        </ng-template>
    </ng-template>
</div>
